require('./runtime');
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("./utils"));
	else if(typeof define === 'function' && define.amd)
		define(["./utils"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("./utils")) : factory(root["./utils"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(window, function(__WEBPACK_EXTERNAL_MODULE__4__) {
return (window["wpBaUiCarbonToolkit"] = window["wpBaUiCarbonToolkit"] || []).push([[11],{

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireDefault");

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ 181:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(182);


/***/ }),

/***/ 182:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;

var _Collapse = _interopRequireDefault(__webpack_require__(183));

exports["default"] = _Collapse["default"];
exports.Collapse = _Collapse["default"];

/***/ }),

/***/ 183:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(2);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _utils = __webpack_require__(4);

var _reactCollapse = __webpack_require__(184);

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
var omit = _utils.lodash.omit;

var Collapse = /*#__PURE__*/function (_Component) {
  (0, _inheritsLoose2["default"])(Collapse, _Component);

  function Collapse() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = Collapse.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        isOpened = _this$props.isOpened,
        autoUnmount = _this$props.autoUnmount;
    var passThroughProps = (0, _extends2["default"])({}, omit(this.props, 'autoUnmount'));
    return autoUnmount ? /*#__PURE__*/_react["default"].createElement(_reactCollapse.UnmountClosed, (0, _extends2["default"])({}, passThroughProps, {
      "aria-expanded": isOpened,
      role: "region"
    })) : /*#__PURE__*/_react["default"].createElement(_reactCollapse.Collapse, (0, _extends2["default"])({}, passThroughProps, {
      "aria-expanded": isOpened,
      role: "region"
    }));
  };

  return Collapse;
}(_react.Component);

exports["default"] = Collapse;
(0, _defineProperty2["default"])(Collapse, "propTypes", (0, _extends2["default"])({
  autoUnmount: _propTypes["default"].bool
}, _reactCollapse.Collapse.propTypes));
(0, _defineProperty2["default"])(Collapse, "defaultProps", {
  autoUnmount: false
});

/***/ }),

/***/ 184:
/***/ (function(module, exports) {

module.exports = require("react-collapse");

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireWildcard");

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__4__;

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/inheritsLoose");

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/extends");

/***/ })

},[[181,0]]]);
});